import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import Container from "@mui/material/Container"
import Stack from "@mui/material/Stack"
import Typography from "@mui/material/Typography"
import { styled } from "@mui/material/styles"
import { HERO } from "@/features/landing/content"
import { Link } from "react-router-dom"

const StyledBox = styled("div")(({ theme }) => ({
  alignSelf: "center",
  width: "100%",
  display: "none",
  height: 400,
  marginTop: theme.spacing(8),
  borderRadius: (theme.vars || theme).shape.borderRadius,
  outline: "6px solid",
  outlineColor: "hsla(220, 25%, 80%, 0.2)",
  border: "1px solid",
  borderColor: (theme.vars || theme).palette.grey[200],
  boxShadow: "0 0 12px 8px hsla(220, 25%, 80%, 0.2)",
  backgroundImage: `url(https://mui.com/static/screenshots/material-ui/getting-started/templates/dashboard.jpg)`,
  backgroundSize: "cover",
  [theme.breakpoints.up("sm")]: {
    marginTop: theme.spacing(10),
    height: 700
  },
  ...theme.applyStyles("dark", {
    boxShadow: "0 0 24px 12px hsla(210, 100%, 25%, 0.2)",
    backgroundImage: `url(https://mui.com/static/screenshots/material-ui/getting-started/templates/dashboard-dark.jpg)`,
    outlineColor: "hsla(220, 20%, 42%, 0.1)",
    borderColor: (theme.vars || theme).palette.grey[700]
  })
}))

interface HeroProps {
  onGetStarted?: (email?: string) => void
}

export default function Hero({ onGetStarted }: HeroProps) {
  return (
    <Box
      id="hero"
      sx={theme => ({
        width: "100%",
        backgroundRepeat: "no-repeat",
        backgroundImage: "radial-gradient(ellipse 80% 50% at 50% -20%, hsl(210, 100%, 90%), transparent)",
        ...theme.applyStyles("dark", {
          backgroundImage: "radial-gradient(ellipse 80% 50% at 50% -20%, hsl(210, 100%, 16%), transparent)"
        })
      })}>
      <Container
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          pt: { xs: 14, sm: 20 },
          pb: { xs: 8, sm: 12 }
        }}>
        <Stack spacing={2} useFlexGap sx={{ alignItems: "center", width: { xs: "100%", sm: "70%" } }}>
          <Typography
            variant="h1"
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              alignItems: "center",
              fontWeight: "800",
              fontSize: "clamp(2rem, 10vw, 2.5rem)"
            }}>
            {HERO.headlineStart}&nbsp;
            <Typography
              component="span"
              variant="h1"
              sx={theme => ({
                fontSize: "inherit",
                fontWeight: "800",

                color: "primary.main",
                ...theme.applyStyles("dark", {
                  color: "primary.light"
                })
              })}>
              {HERO.headlineHighlight}
            </Typography>
          </Typography>
          <Typography
            variant="h1"
            sx={{
              fontWeight: "800",

              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              alignItems: "center",
              fontSize: "clamp(2rem, 10vw, 2.5rem)"
            }}>
            {" "}
            From A Single Photo
          </Typography>
          <Typography
            sx={{
              textAlign: "center",
              color: "text.secondary",
              fontWeight: "700",
              width: { sm: "100%", md: "80%" }
            }}>
            {HERO.body}
          </Typography>
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={1}
            useFlexGap
            sx={{ pt: 2, width: { xs: "100%", sm: "auto" } }}>
            <Button
              variant="contained"
              color="primary"
              size="small"
              sx={{ minWidth: "fit-content" }}
              onClick={() => onGetStarted?.()}>
              {HERO.ctaLabel}
            </Button>
          </Stack>
          <Typography variant="caption" sx={{ color: "text.secondary", textAlign: "center" }}>
            {HERO.disclaimerPrefix}
            <Link to={HERO.disclaimerLinkHref} color="primary">
              {HERO.disclaimerLinkLabel}
            </Link>
            .
          </Typography>
        </Stack>
        <StyledBox id="image" />
      </Container>
    </Box>
  )
}
